import React from "react";

const AutocompleteResults = ({ children, id = "search-results" }) => {
  return (
    <ul className="autocomplete-results" id={id}>
      {children}
    </ul>
  );
};

export default AutocompleteResults;
